module.exports = __webpack_public_path__ + "assets/orange-md-logo-5eb863.svg";